import API from 'src/api'
import { http } from '../boot/axios'
import utils from 'src/utils'
import { Capacitor } from '@capacitor/core'

export default {
  GRAPHQL_URL: `${API.GRAPHQL_URL}routineEvents`,

  createEvent (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}`, payload)
        .then(response => resolve(response.data.data))
        .catch(error => reject(error))
    })
  },
  // TKT-2245 F4 — junto con las actividades viene el mapa de capacidades de edicion
  // que el backend autoriza para este usuario. Si la respuesta no lo trae (backend
  // anterior a la Fase 4) queda vacio, y el configurador se comporta como congelado.
  getFilteredEvents ({ routineId, filters }) {
    const payload = { params: { routineId, filters } }
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}/getFilteredEvents`, payload)
        .then(response => resolve({
          events: response.data.data,
          capabilities: response.data.capabilities || {}
        }))
        .catch(error => reject(error))
    })
  },
  deleteEvent (eventId) {
    return new Promise((resolve, reject) => {
      http.delete(`${this.GRAPHQL_URL}/${eventId}`)
        .then(response => resolve(response.data.data))
        .catch(error => reject(error))
    })
  },
  updateEvent (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}/updateEvent/${payload.eventId}`, payload)
        .then(response => resolve(response.data.data))
        .catch(error => reject(error))
    })
  },
  getUserActivities (params) {
    const payload = { params: params }
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}/userActivities`, payload)
        .then(response => resolve(response.data.data))
        .catch(error => reject(error))
    })
  },
  downloadFastTrackingReport (payload) {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}/downloadFastTrackingReport`, {
        params: payload,
        responseType: 'blob'
      })
        .then(async res => {
          if (Capacitor.isNativePlatform()) {
            utils.download(`Reporte de seguimiento rápido.pdf`, res.data, 'application/pdf')
          } else {
            const { saveAs } = await import('file-saver')
            saveAs(new Blob([res.data], { type: 'application/pdf' }), 'Reporte de seguimiento rápido.pdf')
          }
          resolve(res)
        })
        .catch(err => reject(err))
    })
  }
}
